import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { v4 as uuid } from "uuid";

type Props = Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "onChange" | "value" | "placeholder" | "rows" | "className"> & {
    label?: string | React.ReactNode;
    help?: string;
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    rows?: number;
    className?: string;
};

export function TextareaInput({ label, help, value, onChange, placeholder, rows, className, ...rest }: Props) {
    const id = uuid();

    return (
        <label htmlFor={id} className={css(className || "")}>
            <span className={css("form-label")}>{label}</span>
            <textarea
                id={id}
                className={css("form-input form-textarea")}
                value={value}
                rows={rows}
                onChange={(e) => onChange?.(e.target.value)}
                placeholder={placeholder || __("Type here...", "antimanual")}
                {...rest}
            />
            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}
